import { UnauthorizedError } from '../../utilities/Errors/UnauthorizedError';
import { useQuery } from 'react-query';
import { useZoneContext } from '../../contexts/useZoneContext';

export const userGetReportTypeDetailKey = 'get-report-type-detail';

export const userGetReportTypeDetail = (typeId: number) => {
    const { zoneApiClient } = useZoneContext();

    return useQuery({
        queryKey: [userGetReportTypeDetailKey, { typeId }],
        queryFn: async () => {
            const response = await zoneApiClient.getReportTypeDetail(typeId);

            if (response.httpResponse.status === 401) {
                throw new UnauthorizedError();
            }

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to load the report details.');
            }

            return response.payload;
        },
        enabled: typeId > 0,
        cacheTime: 0,
        staleTime: 0,
    });
};
